import { useBreakpoint } from "@povio/ui";
import Image from "next/image";
import type { SVGProps } from "react";

import LogoMobile from "@/assets/images/general/DogHeadMobile.png";
import Logo from "@/assets/images/general/LogoSidenav.png";
import LogoDemo from "@/assets/images/general/LogoSidenavDemo.png";
import LogoDemoDev from "@/assets/images/general/LogoSidenavDemoDev.png";
import { AppConfig } from "@/config/app.config";
// import LogoDemoDev from "@/assets/images/general/LogoDemoDev.png";
// import { AppConfig } from "@/config/app.config";
import { DemoContext } from "@/providers/demo/DemoContext";

/**
 * Smart logo component that displays the appropriate logo based on:
 * 1. Demo mode in dev environment (highest priority) - shows LogoDemoDev
 * 2. Demo mode in other environments - shows LogoDemo
 * 3. Default logo (production/staging non-demo) - shows default SVG
 */
export const LogoSmartIcon = (props: SVGProps<SVGSVGElement>) => {
  const { isDemoMode } = DemoContext.useDemo();
  const isDevEnvironment =
    AppConfig.stage === "dev" || AppConfig.stage === "development" || AppConfig.stage === "local";

  const isDesktop = useBreakpoint("xl");

  if (!isDesktop) {
    return (
      <div className="h-[38px] w-[38px] overflow-hidden">
        <Image
          src={LogoMobile}
          alt="Lossdog"
          className={props.className}
        />
      </div>
    );
  }

  if (isDemoMode && isDevEnvironment) {
    return (
      <Image
        src={LogoDemoDev}
        alt="LossDog Demo Dev"
        className={props.className}
      />
    );
  }
  if (isDemoMode && !isDevEnvironment) {
    return (
      <Image
        src={LogoDemo}
        alt="LossDog Demo"
        className={props.className}
      />
    );
  }

  return (
    <Image
      src={Logo}
      alt="Lossdog"
      className={props.className}
    />
  );
};
